<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :class="classProps"
        v-bind="attrs"
        v-on="on"
        icon
        @click="$emit('click', $event)"
        :right="right"
        :disabled="disabled"
      >
        <v-icon color="primaryDark" :small="small"
          >mdi-close</v-icon
        >
      </v-btn>
    </template>
    <span>{{ $t("btnClose") }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CloseIcon",
  props: {
    right: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    classProps: { type: String, default: "" },
  },
};
</script>